
import actions from './actions'
import routerOperations from '../router/operations'
import searchResponseOperations from 'tickets/redux/modules/searchResponses/operations'
import { ticketsOffsiteRedirectPath } from 'common/utils/paths'
import { getUnknownQueryParams } from 'tickets/utils/urlUtils'
import { postDataToPage } from 'common/utils/requestUtils'
import { getLanguageCode } from 'tickets/redux/modules/user/selectors'
import { getSearchIsReturn } from 'tickets/redux/modules/searchParams/selectors'
import { getIsTimeAware } from 'tickets/redux/modules/modesInfo/selectors'
import {
  getActiveItineraries,
  getSelectedModeRequestId
} from 'tickets/redux/modules/searchResponses/selectors'

const clearResults = () => (dispatch) => {
  dispatch(routerOperations.clearResults())
}

const modeSelected = actions.modeSelected
const modeInitialized = actions.modeInitialized

const outboundFareClassesChanged = actions.outboundFareClassesChanged
const inboundFareClassesChanged = actions.inboundFareClassesChanged

const outboundTicketSelected = (modeId, ticketID) => (dispatch, getState) => {
  dispatch(routerOperations.outboundTicketSelected(ticketID))
  dispatch(actions.outboundTicketSelected(ticketID))

  // Force a time change if this is a time-aware search and there are no compatible inbound
  // journeys for the selected outbound journey
  const state = getState()
  const isReturn = getSearchIsReturn(state)
  const isTimeAware = getIsTimeAware(state)
  const itins = getActiveItineraries(state)
  if (isReturn && isTimeAware && itins.length == 0) {
    dispatch(searchResponseOperations.forceTimeChange())
  }
}

const inboundTicketSelected = (modeId, ticketID) => (dispatch) => {
  dispatch(routerOperations.inboundTicketSelected(ticketID))
  dispatch(actions.inboundTicketSelected(ticketID))
}

const inboundTicketRemoved = () => (dispatch) => {
  dispatch(actions.inboundTicketRemoved())
  dispatch(routerOperations.inboundTicketRemoved())
}

const outboundTicketRemoved = () => (dispatch) => {
  dispatch(routerOperations.clearResults())
  dispatch(actions.clearResults())
}

const modeChanged = actions.modeChanged

const bookingOpenNextStep = (
  url,
  outboundBookingData,
  inboundBookingData,
  returnBookingData,
  checkoutExitLabel,
  languageCode,
  requestId,
) => {
  const inputs = []

  if (returnBookingData) {
    // Must be outbound because that's what the backend expects.
    // todo: Allow back-end to accept 'returnBookingData'
    inputs.push({ name: 'outboundBookingData', value: returnBookingData })
  } else {
    if (outboundBookingData) {
      inputs.push({ name: 'outboundBookingData', value: outboundBookingData })
    }

    if (inboundBookingData) {
      inputs.push({ name: 'inboundBookingData', value: inboundBookingData })
    }
  }
  if (checkoutExitLabel) {
    inputs.push({ name: 'checkoutExitLabel', value: checkoutExitLabel })
  }
  if (languageCode) {
    inputs.push({ name: 'languageCode', value: languageCode })
  }
  if (requestId) {
    inputs.push({ name: 'requestId', value: requestId })
  }

  const unknownParams = getUnknownQueryParams()
  if (unknownParams && Object.keys(unknownParams).length > 0) {
    inputs.push({ name: 'additionalInformation', value: JSON.stringify(unknownParams) })
  }

  postDataToPage(url, inputs, true)
}

const bookingOffSiteRedirect = (outboundBookingData, inboundBookingData, returnBookingData, languageCode, requestId) => {
  bookingOpenNextStep(
    ticketsOffsiteRedirectPath,
    outboundBookingData,
    inboundBookingData,
    returnBookingData,
    null,
    languageCode,
    requestId
  )
}

const bookingInitiated = (outboundBookingData, inboundBookingData,
  returnBookingData) => (dispatch, getState) => {
    dispatch(actions.boookNowInitated())
    const state = getState()
    const languageCode = getLanguageCode(state)
    const requestId = getSelectedModeRequestId(state)
    bookingOffSiteRedirect(outboundBookingData, inboundBookingData, returnBookingData, languageCode, requestId)
  }

export default {
  outboundTicketSelected,
  inboundTicketSelected,
  outboundTicketRemoved,
  inboundTicketRemoved,
  clearResults,
  modeSelected,
  modeInitialized,
  outboundFareClassesChanged,
  inboundFareClassesChanged,
  bookingInitiated,
  modeChanged,
}
